// src/pages/MSMEHome.jsx
import React, { useState, useRef } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { logout } from "../../redux/actions/authActions";

const MSMEHome = () => {
  const authState = useSelector((state) => state.authReducer || {});
  const isLoggedIn = authState?.isLoggedIn || false;
  const userName = authState?.user?.name || "User";

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [activeTab, setActiveTab] = useState("Learning & Development");

  const handleLogout = () => {
    dispatch(logout());
    navigate("/");
  };

  const groupNames = [
    { label: "Smart Owner", emoji: "🤵" },
    { label: "Anugya", emoji: "🔓" },
    { label: "Digital Income", emoji: "💰" },
    { label: "Learning & Development", emoji: "📚" },
    { label: "MSME Productivity", emoji: "⚡" },
    { label: "Lazy MSME", emoji: "⚡" },
    { label: "Micro CCM", emoji: "📅" },
    { label: "MSME Kaizen", emoji: "🔄" },
    { label: "Finance & Compliance", emoji: "💳" },
    { label: "People & Innovation", emoji: "👥" },
    { label: "Find Workers", emoji: "👷" },
    { label: "PehchaanSetu", emoji: "🌉" },
    { label: "Market & Engagement", emoji: "🛍️" },
    { label: "Owner Self Reflection", emoji: "🪞" },
    { label: "Bias-Variance", emoji: "⚖️" },
    { label: "SigmaStudio", emoji: "🧮" },
    { label: "SprintCentral", emoji: "📅" },    
    { label: "Processifyd", emoji: "🧱" },    
    { label: "Artificial MSME Intelligence", emoji: "👳" },   
    { label: "MSME Games", emoji: "🎮" },
    { label: "SAKSHAM Adoption", emoji: "🧗" },
    { label: "Exim Lens", emoji: "🧭" },  
    { label: "Think5Whys Research Desk", emoji: "🧠" },        
  ];

  const menuButtons1 = [
    // 💰 DIGITAL INCOME & Awards
    { label: "My Income Credit", emoji: "🌱", link: "/myincomecredits", group: "Digital Income" },
    { label: "My Income", emoji: "💰", link: "/myincome", group: "Digital Income" },
    { label: "Income Estimation", emoji: "🔗", link: "/orderflow-earning-estimator", group: "Digital Income" },
    { label: "Kharcho Jeeto", emoji: "🗓️", link: "/kharchojeeto", group: "Digital Income" },
    { label: "Photo Can Win", emoji: "🏁", link: "/photocanwin", group: "Digital Income" },
    { label: "Become Reseller", emoji: "♻️", link: "/msme-enroll", group: "Digital Income" },
    { label: "Rewarding Ads", emoji: "🎁📢", link: "/visigift-home", group: "Digital Income" },
    { label: "Watch Rewarding Videos", emoji: "🎥", link: "/orderflow-spotbuy", group: "Digital Income" },
    { label: "Create Digital Boutique", emoji: "🛍️", link: "/digiboutique", group: "Digital Income" },

    // 📚 Learning & Development
    { label: "MSME Success Kit", emoji: "🧰", link: "/startupkit", group: "Learning & Development" },
    { label: "MSME Learning", emoji: "🗓️", link: "/msme-bookworld", group: "Learning & Development" },
    { label: "MSME Bookshelf", emoji: "📖", link: "/bookshelf", group: "Learning & Development" },
    { label: "MSME Shorts", emoji: "🗞️", link: "/litenshort", group: "Learning & Development" },
    { label: "MSME Trainings & Workshops", emoji: "🎓", link: "/enroll/workshop", group: "Learning & Development" },
    { label: "Podcast", emoji: "️🎙️", link: "/podcast-mylist", group: "Learning & Development" },
    { label: "msmeTube", emoji: "️▶️", link: "/msmetube", group: "Learning & Development" },
    { label: "startupTube", emoji: "⏩", link: "/startuptube", group: "Learning & Development" },

    // 🔄 MSME Kaizen
    { label: "TRACK", emoji: "🚦", link: "/msme-track", group: "MSME Kaizen" },    
    { label: "MSME Ranking", emoji: "🏆", link: "/udyampragatiscore", group: "MSME Kaizen" },
    { label: "Process Scorecard", emoji: "📈", link: "/msme-processscore", group: "MSME Kaizen" },
    { label: "SAKSHAM Database", emoji: "💾", link: "/msmedb", group: "MSME Kaizen" },
    { label: "Business AI Counselling", emoji: "🧠", link: "/aicounselling", group: "MSME Kaizen" },

    // Finance & Compliance
    { label: "Compliances", emoji: "⚠️", link: "/msme-compliances", group: "Finance & Compliance" },
    { label: "NPA Solutions", emoji: "⚠️", link: "/msme-npahome", group: "Finance & Compliance" },
    { label: "Funding & Loans", emoji: "💰", link: "/fundlanes", group: "Finance & Compliance" },

    // MSME Productivity
    { label: "MSME Index Assessment", emoji: "🎯", link: "/msme-index", group: "MSME Productivity" },    
    { label: "Process Maturity Assessment", emoji: "🧠", link: "/msme-selfassessment", group: "MSME Productivity" },    
    // { label: "Business Digital Card", emoji: "💼", link: "/msme-digitalcard", group: "MSME Productivity" },
    { label: "MSME Year Book", emoji: "📚", link: "/msmeyb-home", group: "MSME Productivity" },
    { label: "DeepThinking Lab", emoji: "🔍", link: "/fivewhys-analysis-home", group: "MSME Productivity" },
    { label: "Business Chronicles", emoji: "📖", link: "/msme-business-chronicles", group: "MSME Productivity" },
    { label: "Business Diary", emoji: "📓", link: "/mydiary-home", group: "MSME Productivity" },
    { label: "Business Journal", emoji: "🗒️", link: "/myjournal-home", group: "MSME Productivity" },
    { label: "Minutes of Meeting", emoji: "✍️", link: "/tasks/add", group: "MSME Productivity" },
    { label: "Goal Board", emoji: "🏁", link: "/msme-goalboard", group: "MSME Productivity" },
    { label: "Process & RACI Board", emoji: "🧩", link: "/msme-processraci", group: "MSME Productivity" },
    { label: "Kanban", emoji: "📊", link: "/sigmastudio-kanban", group: "MSME Productivity" },
    { label: "CommuniCapture", emoji: "📢", link: "/communicapture-home", group: "MSME Productivity" },
    { label: "TrackBuddy AI", emoji: "📍", link: "/trackbuddy", group: "MSME Productivity" },
    { label: "LLM Capture", emoji: "🧠🤖", link: "/msme-llmcapture", group: "MSME Productivity" },
    { label: "Auto Payment Reminder", emoji: "⏰💳", link: "/prs", group: "MSME Productivity" },
    { label: "MSME KRA", emoji: "📌", link: "/sigmastudio-kra", group: "MSME Productivity" },
    { label: "MSME KPI", emoji: "🎛️", link: "/sigmastudio-kpi", group: "MSME Productivity" },
    
    // Lazy MSME
    { label: "Lazy Bill Creation", emoji: "🎯", link: "/msme-voicebill", group: "Lazy MSME" },  
    { label: "Lazy Barter", emoji: "🎯", link: "", group: "Lazy MSME" },  
    { label: "Lazy Accounting", emoji: "🎯", link: "", group: "Lazy MSME" },  
    { label: "Lazy Worker Search", emoji: "🎯", link: "", group: "Lazy MSME" },  
    { label: "Lazy Visiting Card", emoji: "🎯", link: "", group: "Lazy MSME" },  

    // 🔄 MSME CCM (Contacts. Communication. Meetings)
    { label: "My Digital Card", emoji: "💼", link: "/msme-digitalcard", group: "Micro CCM" },
    { label: "Client's Digital Card", emoji: "👤", link: "/contact-genious-clientcards", group: "Micro CCM" },
    { label: "My Speaking Card", emoji: "🎙️", link: "/contact-genious-speakingcard", group: "Micro CCM" },
    { label: "Card Visibility Dashboard", emoji: "📊", link: "/contact-genious-cardviewstats", group: "Micro CCM" },
    { label: "Connect / PehchaanSetu", emoji: "🤝", link: "/pehchaansetu", group: "Micro CCM" },
    { label: "Meeting Calendar", emoji: "📅", link: "/calendar-list", group: "Micro CCM" },
    { label: "Visits for Meeting", emoji: "📍", link: "/visits-list", group: "Micro CCM" },
    { label: "Meeting Thoughts", emoji: "💭", link: "/thoughts-list", group: "Micro CCM" },
    { label: "Meeting TODO", emoji: "✅", link: "/todo-list", group: "Micro CCM" },
    { label: "Meeting Tasks", emoji: "🛠️", link: "/tasks-list", group: "Micro CCM" },
    { label: "Travelling for Meetings", emoji: "🚗", link: "/travels-list", group: "Micro CCM" },
    { label: "Meeting Checklist", emoji: "📋", link: "/checklist-list", group: "Micro CCM" },
    { label: "Meeting Record", emoji: "🗂️", link: "/meetings-list", group: "Micro CCM" },
    { label: "Whisper", emoji: "🤫", link: "", group: "Micro CCM" },
    { label: "Meeting Analytics AI", emoji: "🧠📈", link: "", group: "Micro CCM" },

    // 🪞 SELF REFLECTION
    { label: "Personal Digital Card", emoji: "📘", link: "/msme-digitalcard", group: "Owner Self Reflection" },
    { label: "Owner's Self Management", emoji: "🙋‍♀️", link: "/msme-self-chronicles", group: "Owner Self Reflection" },
    { label: "Personal Diary", emoji: "📔", link: "/mydiary-home", group: "Owner Self Reflection" },
    { label: "DeepThinking", emoji: "🧩", link: "/fivewhys-analysis-home", group: "Owner Self Reflection" },
    { label: "Focus Timer", emoji: "⏱️", link: "/msme-focustimerstart", group: "Owner Self Reflection" },
    { label: "IKIGAI", emoji: "🌸", link: "/myprofile-ikigai", group: "Owner Self Reflection" },
    { label: "My Outreach", emoji: "📣👥", link: "/outreach", group: "Owner Self Reflection" },
    { label: "My Limit", emoji: "️📏", link: "/mylimit", group: "Owner Self Reflection" },
    { label: "Personal AI Counselling", emoji: "🧑‍💼🤖", link: "/aicounselling", group: "Owner Self Reflection" },
    { label: "Owner Productivity Suite", emoji: "🧠⚙️", link: "", group: "Owner Self Reflection" },    

    // 👥 People & Innovation
    { label: "Digital Boutique", emoji: "🏬", link: "/digiboutique", group: "People & Innovation" },
    { label: "Consultants", emoji: "🧑‍💼", link: "/think5whys-counsellors", group: "People & Innovation" },
    { label: "Offboarded DB", emoji: "📤", link: "/offboarded-home", group: "People & Innovation" },
    { label: "Payment Dodger DB", emoji: "🚫💰", link: "/offboarded-home", group: "People & Innovation" },
    { label: "Design Of Experiments", emoji: "🧪", link: "/doe", group: "People & Innovation" },
    { label: "Innovations", emoji: "🚀", link: "/msme-innovationhub", group: "People & Innovation" },
    { label: "MSME2Farmers", emoji: "🌾🤝", link: "/mykisan", group: "People & Innovation" },

    // PehchaanSetu 
    { label: "PehchaanSetu", emoji: "🔗", link: "/pehchaansetu", group: "PehchaanSetu" },

    // Find Workers  
    { label: "Workers (BlueHands)", emoji: "👷", link: "/bluehands-home", group: "Find Workers" },

    // Market & Engagement
    { label: "MSME Marketplace", emoji: "🏪", link: "/orderflow-home", group: "Market & Engagement" },
    { label: "Marketing Campaigns", emoji: "📣", link: "/treach", group: "Market & Engagement" },
    { label: "CSAT", emoji: "💬", link: "/csat", group: "Market & Engagement" },
    { label: "BoloGrahak", emoji: "🙋‍♀️", link: "/bolograhak", group: "Market & Engagement" },
    { label: "Forum", emoji: "🗣️", link: "/povify-home", group: "Market & Engagement" },
    { label: "TwiWrold", emoji: "🌐", link: "/twiworld", group: "Market & Engagement" },
    { label: "MSME MetaVerse", emoji: "🕶️", link: "/msme-metaverse", group: "Market & Engagement" },

    // MSME  Games
    { label: "MSME Tambola", emoji: "🎟️", link: "/msme-games-tambola", group: "MSME Games" },
    { label: "MSME Bingo", emoji: "🔢", link: "/msme-games-bingo", group: "MSME Games" },    
    { label: "Mind of a CEO Series", emoji: "🧠", link: "/msme-games-strategic", group: "MSME Games" },
    { label: "Operational Intelligence", emoji: "⚙️", link: "/msme-games-operational", group: "MSME Games" },
    { label: "Relaxation + Clarity", emoji: "🎯", link: "/msme-games-edutainment", group: "MSME Games" },
    { label: "Other MSME Games", emoji: "🕹️", link: "/msme-games-other", group: "MSME Games" },

    // SAKSHAM Adoption
    { label: "Ladder", emoji: "🪜", link: "/msme-think5whysmaturity", group: "SAKSHAM Adoption" },
    { label: "Stakeholders", emoji: "👨‍💼", link: "/msme-think5whysroles", group: "SAKSHAM Adoption" },
    { label: "SAKSHAM MSME Advisor", emoji: "🤝", link: "/msme-advisors", group: "SAKSHAM Adoption" },
    { label: "Empowering PMMY Enterprises", emoji: "💪", link: "/growsure", group: "SAKSHAM Adoption" },

    // Artificial MSME Intelligence
    { label: "Ask Thinky", emoji: "👳", link: "/ami", group: "Artificial MSME Intelligence" },
    { label: "Work with AI", emoji: "🤖", link: "/msme-vsai", group: "Artificial MSME Intelligence" },
    { label: "AI for MSME", emoji: "👨‍💼", link: "/agenticsim", group: "Artificial MSME Intelligence" },

    // Bias-Variance
    { label: "Bias-Varinace Analysis", emoji: "📚", link: "/bv-usecases", group: "Bias-Variance" },
    { label: "My Bias-Variance History", emoji: "📊", link: "/bv-myhistory", group: "Bias-Variance" },
    { label: "About", emoji: "⚖️", link: "/bv-about", group: "Bias-Variance" },
    
    // SigmaStudio
    { label: "My Variations (Bell Curve)", emoji: "📋", link: "/sigmastudio-variations", group: "SigmaStudio" },
    { label: "Calculators", emoji: "🧮", link: "/sigmastudio-calculators", group: "SigmaStudio" },
    { label: "SIPOC", emoji: "🗺️", link: "/sigmastudio-sipoc", group: "SigmaStudio" },
    { label: "Process Flow", emoji: "🔀", link: "/sigmastudio-processcharts", group: "SigmaStudio" },
    { label: "Pareto Analysis", emoji: "📊", link: "/sigmastudio-pareto", group: "SigmaStudio" },
    { label: "5 Whys", emoji: "❓", link: "/fivewhys-analysis-home", group: "SigmaStudio" },
    { label: "5S", emoji: "🧹", link: "/fives-home", group: "SigmaStudio" },
    { label: "Poka-Yoke", emoji: "🛡️", link: "/sigmastudio-pokayoke", group: "SigmaStudio" },
    { label: "Kanban", emoji: "🪜", link: "/sigmastudio-kanban", group: "SigmaStudio" },
    { label: "Kaizen", emoji: "🔁", link: "/mykaizen-home", group: "SigmaStudio" },
    { label: "FMEA", emoji: "🔁", link: "/sigmastudio-fmea", group: "SigmaStudio" },
    { label: "7 Mudas", emoji: "🔁", link: "/sigmastudio-7mudas", group: "SigmaStudio" },
    { label: "Control Charts", emoji: "📈", link: "/sigmastudio-controlcharts", group: "SigmaStudio" },
    { label: "Fishbone (Ishikawa)", emoji: "🐟", link: "/fishbone-home", group: "SigmaStudio" },
    { label: "DOE", emoji: "🧪", link: "/doe", group: "SigmaStudio" },
    { label: "Gauge R&R", emoji: "📏", link: "/sigmastudio-rnr", group: "SigmaStudio" },
    { label: "Matrix Charts", emoji: "🗂️", link: "/sigmastudio-matrix", group: "SigmaStudio" },
    { label: "RACI Matrix", emoji: "👥", link: "/sigmastudio-raci", group: "SigmaStudio" },
    { label: "KRAs", emoji: "🎯", link: "/sigmastudio-kra", group: "SigmaStudio" },
    { label: "KPIs", emoji: "🏁", link: "/sigmastudio-kpi", group: "SigmaStudio" },

    // SprintCentral
    { label: "Three Points Formula", emoji: "🧮", link: "/sprintcentral-threepf", group: "SprintCentral" },
    { label: "WBS & PERT", emoji: "🧮", link: "/sprintcentral-wbs", group: "SprintCentral" },
    { label: "Projects", emoji: "📁", link: "/sprintcentral-projects", group: "SprintCentral" },
    { label: "Sprint", emoji: "🏃", link: "/sprintcentral-sprints", group: "SprintCentral" },
    { label: "Agile Board", emoji: "🧩", link: "/sprintcentral-agileboard", group: "SprintCentral" },
    { label: "Agile Team", emoji: "👥", link: "/sprintcentral-teams", group: "SprintCentral" },
    { label: "Backlog", emoji: "📝", link: "/sprintcentral-backlogs", group: "SprintCentral" },
    { label: "Epic", emoji: "🗂️", link: "/sprintcentral-epics", group: "SprintCentral" },
    { label: "Story", emoji: "📘", link: "/sprintcentral-story", group: "SprintCentral" },
    { label: "Task", emoji: "✅", link: "/sprintcentral-tasks", group: "SprintCentral" },
    { label: "Issue", emoji: "❗", link: "/sprintcentral-issues", group: "SprintCentral" },
    { label: "Agile Meetings", emoji: "📆", link: "/sprintcentral-meetings", group: "SprintCentral" },
    { label: "Cost", emoji: "💰", link: "/sprintcentral-cost", group: "SprintCentral" },
    { label: "Reports", emoji: "📊", link: "/sprintcentral-reports", group: "SprintCentral" },
    { label: "Documents", emoji: "📂", link: "/docsure-home", group: "SprintCentral" },
    { label: "Communications", emoji: "💬", link: "/sprintcentral-messages", group: "SprintCentral" },
    { label: "Root Cause", emoji: "❓", link: "/fivewhys-analysis-home", group: "SprintCentral" },
    { label: "Transformation Intelligence", emoji: "🧠", link: "/sprintcentral-transformation", group: "SprintCentral" },

    // Processifyd
    { label: "Dashboard", emoji: "📊", link: "/processifyd-dashboard", group: "Processifyd" },
    { label: "Clients", emoji: "🏢", link: "/processifyd-clients", group: "Processifyd" },
    { label: "Processes", emoji: "⚙️", link: "/processifyd-processes", group: "Processifyd" },
    { label: "States", emoji: "🔘", link: "/processifyd-states", group: "Processifyd" },
    { label: "State Transitions", emoji: "🔄", link: "/processifyd-statetransitions", group: "Processifyd" },
    { label: "Variables", emoji: "🔣", link: "/processifyd-variables", group: "Processifyd" },  
    { label: "Groups", emoji: "👥", link: "/processifyd-groups", group: "Processifyd" },
    { label: "RACI Persons", emoji: "👥", link: "/processifyd-racipersons", group: "Processifyd" },
    { label: "RACI", emoji: "🧩", link: "/processifyd-raci", group: "Processifyd" },
    { label: "Users", emoji: "👤", link: "/processifyd-users", group: "Processifyd" },
    { label: "Mappings", emoji: "🗺️", link: "/processifyd-mappings", group: "Processifyd" },
    { label: "One-View", emoji: "🧾", link: "/processifyd-oneview", group: "Processifyd" },
    { label: "Approvals", emoji: "✅", link: "", group: "Processifyd" },
    { label: "Help", emoji: "❓", link: "/processifyd-helptexts", group: "Processifyd" },
    { label: "Scripts", emoji: "📜", link: "/processifyd-scripts", group: "Processifyd" },
    { label: "Communications", emoji: "💬", link: "", group: "Processifyd" },
    { label: "References", emoji: "📎", link: "", group: "Processifyd" },
    { label: "Errors", emoji: "⚠️", link: "", group: "Processifyd" },
    { label: "Logs", emoji: "📚", link: "", group: "Processifyd" },
    { label: "IIOT & Telemetry", emoji: "📡", link: "", group: "Processifyd" },
    { label: "Training & Workshops", emoji: "🎓", link: "/enroll/workshop", group: "Processifyd" },
    { label: "BPM Immersive Books", emoji: "🗓️", link: "" },    
    { label: "Immersive Booksshelf", emoji: "📖", link: "/bookshelf" },
    { label: "BPM Skill Certification", emoji: "📜", link: "" }, 

     // EximLens
    { label: "Overview", emoji: "🧭", link: "/eximlens/overview", group: "Exim Lens" },
    { label: "Data Behind the Lens", emoji: "📚", link: "/eximlens/data", group: "Exim Lens" },
    { label: "Market Signals", emoji: "📊", link: "/eximlens/signals", group: "Exim Lens" },
    { label: "Trade Focus Areas", emoji: "🌐", link: "/eximlens/focus", group: "Exim Lens" },
    { label: "Think5Whys Insights", emoji: "🧠", link: "/eximlens/think5whys", group: "Exim Lens" },
    { label: "MSME Action View", emoji: "🎯", link: "/eximlens/action", group: "Exim Lens" },
    { label: "About & Disclaimer", emoji: "ℹ️", link: "/eximlens/about", group: "Exim Lens" },

    // Think5Whys Research Desk
    { label: "Overview", emoji: "🧭", link: "", group: "Think5Whys Research Desk" },
    { label: "Research Library", emoji: "📚", link: "", group: "Think5Whys Research Desk" },
    { label: "Insights", emoji: "💡", link: "", group: "Think5Whys Research Desk" },
    { label: "Ask Research", emoji: "📝", link: "", group: "Think5Whys Research Desk" },
    { label: "Timeline Research", emoji: "🕰️", link: "", group: "Think5Whys Research Desk" },
    { label: "Compliance News", emoji: "📰", link: "/msme-compliance-news", group: "Think5Whys Research Desk" },
    { label: "Compliance Latest Rule", emoji: "📜", link: "/msme-compliance-rules", group: "Think5Whys Research Desk" },
    { label: "Team", emoji: "👩‍🔬", link: "", group: "Think5Whys Research Desk" },
  ];

  const filteredButtons = menuButtons1.filter((btn) => btn.group === activeTab);

  return (
    <div className="min-h-screen flex flex-col bg-black text-gray-100 font-sans">
      <header className="sticky top-0 z-50 bg-black border-b border-blue-400 px-4 py-3 flex items-center justify-between">
        <div className="flex flex-col">
          <div className="text-lg lg:text-xl font-bold text-yellow-200">SAKSHAM MSME</div>
          <div className="text-[11px] text-gray-200">Skilled And Keen, Systematic Hands Achieve More!</div>
          <div className="text-xs text-yellow-200">Owner Centric. Transparency. Connecting Skill with Productivity</div>
        </div>

        <div className="hidden md:flex items-center gap-3">
          {isLoggedIn ? (
            <>
              <div className="text-xs lg:text-sm text-teal-300">{userName}</div>
              <button
                onClick={handleLogout}
                className="w-8 mt-2 px-2 py-1 rounded-md bg-red-600 hover:bg-red-700 transition"
                title="Logout"
              >
                ⏻
              </button>
            </>
          ) : (
            <>
              <button
                onClick={() => navigate("/login")}
                className="w-8 px-2 py-1 rounded-full border border-gray-700 text-sm text-gray-200 hover:bg-gray-800"
              >
                🔐 
              </button>
            </>
          )}
        </div>
        <button
          onClick={() => setIsMobileMenuOpen((s) => !s)}
          className="md:hidden w-8 h-8 flex items-center justify-center text-2xl text-teal-300"
          aria-label="Toggle menu"
        >
          {isMobileMenuOpen ? "×" : "☰"}
        </button>
      </header>

      {isMobileMenuOpen && (
        <div className="md:hidden bg-gray-900 border-b border-gray-800 px-4 py-3">
          {isLoggedIn ? (
            <div className="flex flex-col items-center gap-3">
              <div className="text-teal-300 text-xs lg:text-sm font-medium">{userName}</div>
                <div className="flex gap-3">
                  <button
                    onClick={handleLogout}
                    className="p-2 rounded-md bg-red-600 hover:bg-red-700"
                  >
                    ⏻
                  </button>
                </div>
            </div>
          ) : (
            <div className="flex justify-center gap-6">
              <Link to="/login" className="text-teal-300">🔐</Link>
            </div>
          )}
        </div>
      )}

      <div className="bg-cyan-800 text-white text-xs lg:text-sm py-2">
        <div className="px-1 flex flex-wrap justify-center gap-2">
          {/* <a href="/msme-whysakshammsme" className="hover:text-yellow-200">💭 About</a> */}
          <a href="/msme-think5whysfaq" className="hover:text-yellow-200">🤔 FAQ</a>
          <Link to="/litenshort" className="hover:text-yellow-200">🗞️ MSME News</Link>
          <a href="/fundlanes" className="hover:text-yellow-200">💰 Funding</a>
          <a href="/growsure" className="hover:text-yellow-200">💪 PMMY</a>
          <a href="/ledger" className="hover:text-yellow-200">📊 ERP</a>
          <Link to="/msmeai" className="hover:text-yellow-200">🧠 AI Signals</Link>
          <a href="/agenticsim" className="hover:text-yellow-200">🤖 Ask AI</a>
        </div>
      </div>

      {/* <div className="mt-1 mb-1 px-3 py-2 border-b-2 border-gray-500">
        <div className="grid grid-cols-3 lg:grid-cols-7 gap-1 border-gray-600 place-items-center">
          {groupNames.map((group) => (
            <button
              key={group.label}
              onClick={() => setActiveTab(group.label)}
              className={`flex flex-col items-center justify-center w-full px-1 py-1 rounded-md text-xs font-medium transition ${
                activeTab === group.label
                  ? "bg-teal-700 text-yellow-200"
                  : "bg-gray-800 text-gray-200 hover:bg-gray-700"
              }`}
              aria-pressed={activeTab === group.label}
            >
              <span className="text-lg">{group.emoji}</span>
              <span className="mt-1 text-center">{group.label}</span>
            </button>
          ))}
        </div>
      </div>

      <main className="flex-grow mx-auto px-3 py-2 w-full justify-center items-center text-center">
        <div className="grid grid-cols-3 lg:grid-cols-7 gap-1 place-items-center">
          {filteredButtons.length === 0 ? (
            <div className="col-span-3 lg:col-span-5 text-center text-gray-400">
              No items in this category.
            </div>
          ) : (
            filteredButtons.map((btn, idx) => (
              <button
                key={`${btn.label}-${idx}`}
                onClick={() => navigate(btn.link)}
                className="flex flex-col items-center justify-center w-full px-1 py-1 rounded-md bg-cyan-800 text-xs font-medium transition hover:bg-teal-700 hover:text-yellow-200 text-gray-100 break-words text-center shadow-sm"
                title={btn.label}
              >
                <span className="text-xs lg:text-lg">{btn.emoji}</span>
                <span className="mt-1">{btn.label}</span>
              </button>
            ))
          )}
        </div>
      </main> */}
      <div className="mt-1 mb-1 px-3 py-2 border-b-2 border-gray-500">
        <div className="grid grid-cols-3 lg:grid-cols-7 gap-1 border-gray-600 place-items-center">
          {groupNames.map((group) => {
            const isDirectRoute = group.label === "Smart Owner";
            const isAnugya = group.label === "Anugya";
            return (
              <button
                key={group.label}
                onClick={() => {
                  if (isDirectRoute) {
                    navigate("/msmeownerpa");
                    return;
                  }
                  if (isAnugya) {
                    navigate("/anugya");
                    return;
                  }
                  setActiveTab(group.label);
                }}
                className={`flex flex-col items-center justify-center w-full px-1 py-1 rounded-md text-xs font-medium transition ${
                  activeTab === group.label
                    ? "bg-teal-700 text-yellow-200"
                    : "bg-gray-800 text-gray-200 hover:bg-gray-700"
                }`}
                aria-pressed={activeTab === group.label}
                title={group.label}
              >
                <span className="text-lg">{group.emoji}</span>

                <span className="mt-1 text-center break-words leading-tight">
                  {group.label}
                </span>
              </button>
            );
          })}
        </div>
      </div>

      <main className="flex-grow mx-auto px-3 py-2 w-full justify-center items-center text-center">
        <div className="grid grid-cols-3 lg:grid-cols-7 gap-1 place-items-center">
          {filteredButtons.length === 0 ? (
            <div className="col-span-3 lg:col-span-7 text-center text-gray-400 py-10">
              No items in this category.
            </div>
          ) : (
            filteredButtons.map((btn, idx) => (
              <button
                key={`${btn.label}-${idx}`}
                onClick={() => navigate(btn.link)}
                className="flex flex-col items-center justify-center w-full px-1 py-1 rounded-md bg-cyan-800 text-xs font-medium transition hover:bg-teal-700 hover:text-yellow-200 text-gray-100 break-words text-center shadow-sm"
                title={btn.label}
              >
                <span className="text-xs lg:text-lg">{btn.emoji}</span>

                <span className="mt-1 leading-tight">
                  {btn.label}
                </span>
              </button>
            ))
          )}
        </div>
      </main>
      <footer className="bg-black border-t border-blue-400 text-white py-4">
        <div className="mx-auto px-3 flex flex-col lg:flex-row items-center justify-between gap-3">
          <div className="text-sm text-yellow-200">© 2026 Think5Whys Global DeepTech Solutions.</div>
          <div className="flex flex-wrap gap-4 text-sm">
            <Link to="/about-us" className="hover:text-teal-300">About</Link>
            <Link to="/privacy-policy" className="hover:text-teal-300">Privacy Policy</Link>
            <Link to="/terms-of-use" className="hover:text-teal-300">Terms of Use</Link>
            <Link to="/contact-us" className="hover:text-teal-300">Contact</Link>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default MSMEHome;
